module.exports = __webpack_public_path__ + "img/customer.aa634000.png";